export class FeeProviderCategoryApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFeeProviderCategories() {
    return this.#http.get('/FeeProviderCategory');
  }

  async createFeeProviderCategory(body) {
    return this.#http.post('/FeeProviderCategory', body);
  }

  async updateFeeProviderCategory({ feeProviderCategoryId, ...body }) {
    return this.#http.put(`/FeeProviderCategory/${feeProviderCategoryId}`, body);
  }

  async deleteFeeProviderCategory({ feeProviderCategoryId }) {
    return this.#http.delete(`/FeeProviderCategory/${feeProviderCategoryId}`);
  }
}
